import { render, staticRenderFns } from "./carrito.vue?vue&type=template&id=7b36910f&scoped=true&"
import script from "./carrito.vue?vue&type=script&lang=js&"
export * from "./carrito.vue?vue&type=script&lang=js&"
import style0 from "./carrito.vue?vue&type=style&index=0&id=7b36910f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36910f",
  null
  
)

export default component.exports